'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './user.routes.js';
// import SignupCtrl from './signup/signup.controller.js';
import MeViewCtrl from './me/me.controller.js';
import MePersonalCtrl from './me/personal/personal.controller.js';
import MeContactCtrl from './me/contact/contact.controller.js';
import MeChangePWCtrl from './me/changepassword/changepassword.controller.js';
import MeFinancialCtrl from './me/financial/financial.controller.js';

export default angular.module('georgeApp.user', [uiRouter])
  .config(routing)
  // .controller('SignupCtrl', SignupCtrl)
  .controller('MeViewCtrl', MeViewCtrl)
  .controller('MePersonalCtrl', MePersonalCtrl)
  .controller('MeContactCtrl', MeContactCtrl)
  .controller('MeChangePWCtrl', MeChangePWCtrl)
  .controller('MeFinancialCtrl', MeFinancialCtrl)
  .name;
